import React from 'react';

import C from './controller';
import Icon from './icon';

import {
  Wrap, IconWrap, MsgWrap, BtnWrap
} from './styled';

const Message = ({
  data, // props
  isHover, // state
  removeSelf, mouseEnter, mouseLeave, // func
}) => (
  <Wrap onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
    <IconWrap>
      <Icon name={data.type} width="20" height="20" />
    </IconWrap>
    <MsgWrap>
      {data.title && <p>{data.title}</p>}
      <p>{data.message}</p>
    </MsgWrap>
    <BtnWrap onClick={removeSelf}>
      <Icon name="x" width="15" height="15" />
    </BtnWrap>
  </Wrap>
)

export default C(Message);


// WEBPACK FOOTER //
// ./client/components/Toast/Message/index.js